import apiService from './api.service';

export interface SDKConfiguration {
  apiKey: string;
  appId: string;
  apiEndpoint: string;
}

export interface ScreenshotData {
  screenshot: string;
  width: number;
  height: number;
}

class SDKService {
  private readonly baseUrl = '/v1/analytics';
  private readonly sdkBaseUrl = '/v1/sdk';

  /**
   * Get SDK configuration for an application
   */
  async getSDKConfiguration(applicationId: string): Promise<SDKConfiguration> {
    const response = await apiService.get(`${this.baseUrl}/config`, {
      params: { application_id: applicationId },
    });
    return response.data || response;
  }

  /**
   * Get screenshot for a page/screen
   */
  async getScreenshot(applicationId: string, pageUrl: string): Promise<ScreenshotData | null> {
    try {
      const response = await apiService.get<{ success: boolean; data: ScreenshotData }>(`${this.sdkBaseUrl}/journeys/screenshot`, {
        params: { application_id: applicationId, page_url: pageUrl },
      });
      return response.data || null;
    } catch (error) {
      console.log('[SDKService] Screenshot not found for:', pageUrl);
      return null;
    }
  }
}

export default new SDKService();
